import { render, staticRenderFns } from "./resolutionForecast.vue?vue&type=template&id=4c4a3ac5&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./resolutionForecast.vue?vue&type=style&index=0&id=4c4a3ac5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4a3ac5",
  null
  
)

export default component.exports